import './main.scss'

import './config/jquery'
import './config/chocolat'
import './config/owlCarousel'
import './config/bootstrap'

import './setup'
